module.exports = __webpack_public_path__ + "stars.eb60614eb2685f3be50b29679f21abad.svg";